import { createAction } from '@reduxjs/toolkit';

// step actions
export var setLoading = createAction('SET_LOADING');
export var setNextStep = createAction('SET_NEXT_STEP');
export var setInitData = createAction('SET_INIT_DATA');
export var orderResult = createAction('SET_ORDER_RESULT');
export var setTariffData = createAction('SET_TARIFF_DATA');
export var resetStepsData = createAction('RESET_STEPS_DATA');
export var backToPreviousStep = createAction('BACK_PREVIOUS_STEP');
export var setPopupVisibility = createAction('SET_POPUP_VISIBILITY');
export var setOrderTariffType = createAction('SET_ORDER_TARIFF_TYPE');
export var setAvailablePeriods = createAction('SET_AVAILABLE_PERIODS');
export var setTariffServicesData = createAction('SET_TARIFF_SERVICES_DATA');
export var setAlternativeTariffType = createAction('SET_ALTERNATIVE_TARIFF_TYPE');
export var setConvergenceTariffs = createAction('SET_CONVERGENCE_TARIFFS');
export var setMobileTariffs = createAction('SET_MOBILE_TARIFFS');

// tariff details actions
export var resetTariffData = createAction('RESET_TARIFF_DATA');
export var setSelectedTimeSlot = createAction('SET_SELECTED_TIMESLOTS');
export var setSelectedServices = createAction('SET_SELECTED_SERVICES');

// user data actions
export var setFlat = createAction('SET_FLAT');
export var setHouse = createAction('SET_HOUSE');
export var setStreet = createAction('SET_STREET');
export var resetUserData = createAction('RESET_USER_DATA');
export var setPhoneNumber = createAction('SET_PHONE_NUMBER');
export var setStatusConnection = createAction('SET_STATUS_CONNECTION');
export var setAddressViewValue = createAction('SET_ADDRESS_VIEW');
export var resetAddressData = createAction('RESET_ADDRESS_DATA');